import { Api } from "./api"

export class GreenGradingTypeApi extends Api {
  constructor() {
    super('green_grading_types', [], { prefix: 'green_gradings'})
  }
}
